import { createContext } from 'react';

export type Theme = 'dark' | 'light';

export interface ThemeContextValue {
  theme: Theme;
  toggle: () => void;
  sidebarCollapsed: boolean;
  toggleSidebar: () => void;
}

export const ThemeContext = createContext<ThemeContextValue | undefined>(undefined);
